import { Box, Button, styled, Typography } from "@mui/material";
import Logo from "../../../assets/logos/logo.png";
import { LogoBanner, SubmitBtn } from "../login/ConfirmPhoneNumber";
import CheckIcon from "../../../assets/icons/Check.svg";
import SVG from "react-inlinesvg";
// import Countdown from "react-countdown";
import React, { useEffect, useState, useMemo } from "react";
import { useLanguage } from "../../../hooks/useLanguage";
import { useLocation, useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import { postRegistration } from "../../../services/auth/auth.service";
import ChangeLanguage from "../../../components/ChangeLanguage";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import { Loading } from "../../../components";
import { links } from "../../../constants/links";
import { renderPhoneNumber } from "../../../utils/utils";
import { useTranslation } from "react-i18next";
import {
  SUB_CAMPAIGN_ID_KEY,
  LOGIN_METHOD,
  LIST_LANGUAGE_ENUM,
  APP_NAME,
} from "../../../constants";
import RewardIcon from "../../../assets/icons/Reward.svg";
import ProductIcon from "../../../assets/icons/StarBucks.png";
import Watermark from "../../../assets/images/wattermark.png";
import { ENV } from "../../../configs/env";

const ResendWrapper = styled(Box)({
  padding: "0 20px",
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  paddingBottom: 150,
  "&.error": {
    paddingBottom: 0,
  },
});

const ResendBody = styled(Box)({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  justifyContent: "space-between",
});

export const TextBox = styled(Box)({
  marginTop: 30,
  backgroundColor: "#E7F9EB",
  borderRadius: 10,
  padding: "12px 15px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "& p": {
    color: "#000000",
    opacity: 0.7,
  },
});

const ErrorBox = styled(Box)({
  marginTop: 30,
  backgroundColor: "#FDEFE8",
  borderRadius: 10,
  padding: "12px 15px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "& p": {
    color: "#000000",
    opacity: 0.7,
  },
});

const IconWrapper = styled(Box)({
  width: 70,
  height: 70,
  background:
    "linear-gradient(180deg, #FFFFFF 0%, #D0D5DD 100%), rgba(255, 255, 255, 0.2)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "12px",
  "& img": {
    width: 42,
    height: 42,
  },
});

// const ResendBtn = styled(Button)({
//   fontSize: 14,
//   fontWeight: 400,
//   padding: 0,
//   justifyContent: "flex-start",
// });

const CampaignContent = styled(Box)({
  width: 258,
  height: 258,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundImage: `url(${Watermark})`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  marginTop: 50,
  flexDirection: "column",
  "& p": {
    opacity: 0.7,
  },
});

const lineLiff = [
  LOGIN_METHOD.LINE_LIFF_ADCOINZ,
  LOGIN_METHOD.LINE_LIFF_SR,
  LOGIN_METHOD.LINE_LIFF_TAIWAN,
];
const lineSessionLoginMethods = [
  LOGIN_METHOD.LINE_SESSION_ID,
  LOGIN_METHOD.LINE_ADCOINZ_SESSION_ID,
  LOGIN_METHOD.LINE_TW,
];
const linePhoneLoginMethods = [
  LOGIN_METHOD.LINE_PHONE_NUMBER,
  LOGIN_METHOD.LINE_ADCOINZ_PHONE_NUMBER,
];
const lineAllLoginMethods = [
  ...lineSessionLoginMethods,
  ...linePhoneLoginMethods,
  ...lineLiff,
];

const ResendPhoneNumber = () => {
  const { state } = useLocation();
  const {
    data,
    defaultLoginMethod,
    advertiserLogo: adsDataState,
  } = state || {};
  const adsData = adsDataState || localStorage.getItem("advertiser_logo") || "";
  const searchParams = new URLSearchParams(location.search);
  const appName = state?.appName || searchParams.get("app-name") || "";

  const displayAppName = useMemo(() => {
    if (appName) return appName;
    if (lineAllLoginMethods.includes(defaultLoginMethod)) return APP_NAME.LINE;
    if (
      [LOGIN_METHOD.WHATSAPP, LOGIN_METHOD.TWILIO_WHATSAPP].includes(
        defaultLoginMethod,
      )
    )
      return APP_NAME.WHATSAPP;
    if (defaultLoginMethod === LOGIN_METHOD.SMS) return APP_NAME.SMS;
    return "";
  }, [appName, defaultLoginMethod]);

  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { mutate, isLoading } = useMutation(postRegistration);

  const { language } = useLanguage();

  // Read url from env file
  const LINE_MSG_API_URL = process.env.REACT_APP_LINE_MSG_URL || "";
  const LINE_BOT_BASIC_ID = process.env.REACT_APP_LINE_BOT_BASIC_ID || "";
  const LINE_BOT_BASIC_ID_ADCOINZ =
    process.env.REACT_APP_LINE_BOT_BASIC_ID_ADCOINZ || "";
  const LINE_BOT_BASIC_ID_TW =
    process.env.REACT_APP_LINE_BOT_BASIC_ID_LINE_TW || "";

  interface LineURLType {
    url: string;
    bot_basic_id: string;
    bot_basic_id_adcoinz: string;
    bot_basic_id_line_tw: string;
    defaultLoginMethod: string;
    data: {
      reference_id: string;
    };
  }

  const handleRedirect = (urlObject: LineURLType) => {
    if (!urlObject.url || !urlObject.bot_basic_id) {
      setError("somethingWentWrong");
      return;
    }
    // Check if the default login method is adcoinz, then use the adcoinz bot id
    const botId = [
      LOGIN_METHOD.LINE_ADCOINZ_PHONE_NUMBER,
      LOGIN_METHOD.LINE_ADCOINZ_SESSION_ID,
    ].includes(defaultLoginMethod)
      ? urlObject.bot_basic_id_adcoinz
      : defaultLoginMethod === LOGIN_METHOD.LINE_TW
      ? urlObject.bot_basic_id_line_tw
      : urlObject.bot_basic_id;

    const updatedUrl = urlObject.url
      .replace("{{reference_id}}", data.reference_id)
      .replace("{{bot_basic_id}}", botId ?? "");
    window.location.replace(updatedUrl);
  };

  useEffect(() => {
    if (!LINE_MSG_API_URL || !LINE_BOT_BASIC_ID) {
      setError("somethingWentWrong");
      return;
    }

    const isSessionIdLogin =
      lineSessionLoginMethods.includes(defaultLoginMethod);
    const isPhoneNumberLogin =
      linePhoneLoginMethods.includes(defaultLoginMethod);

    const { reference_id, line_registration_status } = data || {};
    const shouldRedirect =
      reference_id &&
      (isSessionIdLogin ||
        (line_registration_status === "not_registered" && isPhoneNumberLogin));

    if (shouldRedirect) {
      handleRedirect({
        url: LINE_MSG_API_URL,
        bot_basic_id: LINE_BOT_BASIC_ID,
        bot_basic_id_adcoinz: LINE_BOT_BASIC_ID_ADCOINZ,
        bot_basic_id_line_tw: LINE_BOT_BASIC_ID_TW,
        data,
        defaultLoginMethod,
      });
    }
  }, [
    data,
    LINE_MSG_API_URL,
    LINE_BOT_BASIC_ID,
    LINE_BOT_BASIC_ID_ADCOINZ,
    defaultLoginMethod,
    LINE_BOT_BASIC_ID_TW,
  ]);

  return (
    <ResendWrapper className={error ? "error" : ""}>
      {isLoading && <Loading />}
      <LogoBanner id="i-m-top">
        {!ENV.HIDE_LOGO && (
          <img
            className="logo"
            src={
              process.env.REACT_APP_LOGO
                ? "/assets/logo/" + process.env.REACT_APP_LOGO
                : Logo
            }
            alt="logo"
          />
        )}
        {!ENV.HIDE_TRANSLATOR && <ChangeLanguage />}
      </LogoBanner>
      <ResendBody>
        <Box>
          {error ? (
            <ErrorBox>
              <Box mr={2}>
                <ErrorRoundedIcon color="error" />
              </Box>
              <Typography variant="subtitle1">{t(error)}</Typography>
            </ErrorBox>
          ) : lineAllLoginMethods.includes(defaultLoginMethod) ? (
            <TextBox>
              <Box mr={2}>
                <SVG src={CheckIcon} />
              </Box>
              <Typography variant="subtitle1">
                {t("weJustSendTo1")}{" "}
                {
                  <>
                    <b>{String(displayAppName).toUpperCase()}</b>{" "}
                  </>
                }
                {state?.phoneNumberValue &&
                language !== LIST_LANGUAGE_ENUM.JA ? (
                  <>
                    <b>
                      {renderPhoneNumber(
                        state?.prefixValue,
                        state?.phoneNumberValue,
                      )}
                    </b>{" "}
                  </>
                ) : null}
                {t("weJustSendTo2")}
              </Typography>
            </TextBox>
          ) : (
            <TextBox>
              <Box mr={2}>
                <SVG src={CheckIcon} />
              </Box>
              <Typography variant="subtitle1">
                {t("weJustSendTo1")}{" "}
                {language === LIST_LANGUAGE_ENUM.JA ? null : (
                  <>
                    <b>{displayAppName}</b>{" "}
                  </>
                )}
                {state?.phoneNumberValue &&
                language !== LIST_LANGUAGE_ENUM.JA ? (
                  <>
                    <b>
                      {renderPhoneNumber(
                        state?.prefixValue,
                        state?.phoneNumberValue,
                      )}
                    </b>
                    {", "}
                  </>
                ) : null}
                {t("whatsappSend1")}
              </Typography>
            </TextBox>
          )}
        </Box>
        <CampaignContent>
          <IconWrapper>
            {adsData ? (
              <img src={adsData ?? ProductIcon} alt="icon" />
            ) : (
              <SVG src={RewardIcon} />
            )}
          </IconWrapper>
          <Typography
            fontWeight={700}
            mt={2}
            color="primary"
            variant="body2"
            textAlign="center"
          >
            {adsData ? null : t("engageAndEarn")}
          </Typography>
        </CampaignContent>
      </ResendBody>
      {error && (
        <SubmitBtn
          onClick={() => navigate(links.LOGIN)}
          className="submitBtn"
          variant="contained"
        >
          {t("reenterPhoneNumber")}
        </SubmitBtn>
      )}
    </ResendWrapper>
  );
};

export default ResendPhoneNumber;
